import { render, staticRenderFns } from "./NoDataText.vue?vue&type=template&id=4a1bfc4f&scoped=true"
import script from "./NoDataText.vue?vue&type=script&lang=js"
export * from "./NoDataText.vue?vue&type=script&lang=js"
import style0 from "./NoDataText.vue?vue&type=style&index=0&id=4a1bfc4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1bfc4f",
  null
  
)

export default component.exports